import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18n";
import { Loader2, User, Search } from "lucide-react";

export default function Artists() {
  const { t } = useI18n();
  const [artists, setArtists] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/music/artists").then((r) => setArtists(r.data.artists)).catch(() => setArtists([]));
  }, []);

  const filtered = (artists || []).filter((a) => a.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-4 md:p-8 pb-6" data-testid="artists-page">
      <h1 className="font-heading text-3xl font-bold mb-4">{t("all_artists")}</h1>
      <div className="flex items-center gap-2 bg-white/5 rounded-lg px-3 max-w-sm mb-6">
        <Search className="w-4 h-4 text-zinc-500" />
        <input data-testid="artists-filter" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("filter_artists")} className="flex-1 bg-transparent py-2 text-sm focus:outline-none" />
      </div>

      {artists === null ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>
      ) : filtered.length === 0 ? (
        <p className="text-zinc-500 text-sm py-10 text-center">{t("no_artists")}</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {filtered.map((a) => (
            <Link key={a.name} to={`/app/artist/${encodeURIComponent(a.name)}`} data-testid={`artist-grid-${a.name}`} className="bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-colors group">
              {a.thumbnail ? <img src={a.thumbnail} alt="" className="w-full aspect-square rounded-full object-cover" /> : <div className="w-full aspect-square rounded-full bg-white/10 flex items-center justify-center"><User className="w-10 h-10 text-zinc-500" /></div>}
              <p className="text-sm font-semibold truncate mt-3 text-center">{a.name}</p>
              <p className="text-xs text-zinc-400 text-center">{a.track_count} {t("tracks")}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
